<template>
  <van-row id="intro" class="flex-column">
    <!-- NavBar part -->
    <mynavbar></mynavbar>

    <!-- category title -->
    <van-skeleton class="mt-4rem" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title">
      <van-divider class="mt-4rem" style="font-size: 1.2rem;">学校简介</van-divider>
    </van-skeleton>

    <!-- content part -->
    <van-skeleton style="margin-top: 1rem;" :row="10" :loading="sloading">
      <van-row v-if="intro" class="content" v-html="intro"></van-row>
      <van-empty v-else description="暂无记录" />
    </van-skeleton>


    <!-- footer part -->
    <myfooter2></myfooter2>

  </van-row>
</template>

<script>
import navbar from '@/view/navbar/navbar'
import footer2 from '@/view/footer/footer2'

const axios = require('axios')

export default {
  name: 'intro',
  components: {
    'mynavbar' : navbar,
    'myfooter2' : footer2
  },
  data () {
    return {
      sloading: true,
      artId: null,
      intro: '',
      categoryUrl: '/article/category/'
    }
  },
  mounted () {
    let that = this
    // 加载文章
    that.init()
  },
  methods: {
    // 加载文章
    init: function () {
      var that = this
      // 获取简介
      axios.get(that.global.apiUrl + '/web/site/queryAll')
        .then(function (response) {
          if (response.data.success && response.data.data.length > 0) {
            var str = response.data.data[0].intro
            str = str.replace(/api\/file/g, that.global.apiUrl + '/file')
            that.intro = str
            that.sloading = false
          } else if (response.data.success && response.data.data.length == 0) {
            that.sloading = false
            that.intro = ''
          } else {
            that.$router.push({ name: 'page404'})
          }
        })
    }

  }
}
</script>

<style>
.content {
  padding: 0 1rem;
}
.content img {
  max-width: 100%;
  max-height: 15rem;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/view/intro/intro.vue